import {
    isLoading,
    isSuccessfullyLoaded
} from "./modules/api/loading/loading.selector";
import { IApiDataState, IState } from "./store.types";

type DefaultSelectors = {
    isSuccessfullyLoaded: (state: IState) => boolean;
    isLoading: (state: IState) => boolean;
};

export const generateDefaultSelectors = (
    key: keyof IApiDataState
): DefaultSelectors => {
    return {
        isSuccessfullyLoaded: isSuccessfullyLoaded(key),
        isLoading: isLoading(key)
    };
};
